import { ChakraProvider } from '@chakra-ui/react';
import { theme } from '@morressier/alembic';
import { Helmet } from 'react-helmet';
import { QueryClientProvider } from '@tanstack/react-query';
import { FlagProvider } from '@unleash/proxy-client-react';
import IPInfoProvider from 'ip-info-react';
import './styles.css';

import { CookieConsentProvider } from './cookies/CookieConsentContext';
import { unleashConfig } from './lib/unleash';
import AuthRealmEntryPoint from './routes';
import { queryClient } from './utils/queryClient';

function App() {
  return (
    <IPInfoProvider>
      <ChakraProvider theme={theme}>
        <CookieConsentProvider>
          <FlagProvider config={unleashConfig}>
            <QueryClientProvider client={queryClient}>
              <Helmet>
                <title>Journal Manager</title>
              </Helmet>
              <AuthRealmEntryPoint />
            </QueryClientProvider>
          </FlagProvider>
        </CookieConsentProvider>
      </ChakraProvider>
    </IPInfoProvider>
  );
}

export default App;
